import React, { Component } from 'react';
import axios from 'axios';
import {FaEnvelope} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Breadcrumb from "../../../../components/Layout/Breadcrumb";
import ModalComponent from "../../../../components/ModalComponent";
import ServiceGroupEmailComponent from "../../../../components/Admin/emails/services/ServiceGroupEmailComponent";

class ServiceListEmailPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listGroupEmail: [],
            listGroupUser: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            name: '',
            titleGroup: '',
            type_product: '',
            group_user_id: 0,
            stt: 10,
            hidden: false,
            alert: {
                error: false,
                message: ''
            },
            groupId: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.listGroupEmail();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    listGroupEmail = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/getGroupEmailService',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupEmail: ref.data.content,
                        isLoading: false,
                        loadPage: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                // console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu email thất bại',
                    isLoading: false,
                    loadPage: false,
                })
            })
    }

    screentGroupEmail = () => {
        if ( this.state.isLoading ) {
            return (
                <div className="text-center">
                    <Spinner animation="grow" variant="primary" />
                    <Spinner animation="grow" variant="secondary" />
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                </div>
            );
        }
        else {
            if ( this.state.listGroupEmail.length )  {
                return (
                    this.state.listGroupEmail.map( (groupEmail, key) => {
                        return (
                            <ServiceGroupEmailComponent
                                key={key}
                                keyAction={key}
                                groupEmail={groupEmail}
                                showModal = { (keyAction, action) => this.showModal(keyAction, action) }
                            />
                        )
                    })
                )
            }
            else {
                return (
                    <div className="text-center text-danger">
                        Không có sản phẩm trong dữ liệu
                    </div>
                )
            }
        }
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'createGroup' ) {
            titleModal = 'Tạo nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'editGroup' ) {
            titleModal = 'Chỉnh sửa nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'deleteGroup' ) {
            titleModal = 'Xóa nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'deleteProduct' ) {
            titleModal = 'Xóa sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key,
            alert: {
                error: false,
                message: ''
            },
        })
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    modalBody = (key, action) => {
        if ( action === 'createGroup' ) {
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên nhóm email</label>
                        <input type="text" name="name" className="form-control" id="name" placeholder="Tên nhóm email" onChange={this.changeInput} />
                    </div>
                </>
            )
        }
        else if ( action === 'editGroup' ) {
            this.setState({
                name: this.state.listGroupEmail[key].title,
                groupId: this.state.listGroupEmail[key].id,
            })
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên nhóm email</label>
                        <input type="text" name="name" className="form-control" id="name"
                               placeholder="Tên nhóm email" onChange={this.changeInput}
                               defaultValue={ this.state.listGroupEmail[key].title }
                        />
                    </div>
                </>
            )
        }
        else if ( action === 'deleteGroup' ) {
            this.setState({
                groupId: this.state.listGroupEmail[key].id,
            })
            return (
                <div className="text-center">
                    Bạn có muốn xóa nhóm email <b className="text-danger">{this.state.listGroupEmail[key].title}</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về nhóm email này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'deleteProduct' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa email <b className="text-danger">{ key.name }</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về email này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    confirmModal = () => {
        if ( this.validate() ) {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = this.getForm();
            // console.log(form)
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/email/actionGroupEmail', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        if ( this.state.action === 'deleteGroup' ) {
                            if ( !ref.data.error ) {
                                this.state.listGroupEmail.splice( this.state.actionKey , 1);
                            }
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.listGroupEmail();
                            }
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    // console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    getForm = () => {
        if ( this.state.action === 'createGroup' ) {
            return {
                action:  this.state.action,
                title:  this.state.name,
            };
        }
        else if ( this.state.action === 'editGroup' ) {
            return {
                action:  this.state.action,
                title:  this.state.name,
                groupId:  this.state.groupId,
            };
        }
        else if ( this.state.action === 'deleteGroup' ) {
            return {
                action:  this.state.action,
                groupId:  this.state.groupId,
            };
        }
        else if ( this.state.action === 'deleteProduct' ) {
            return {
                action:  this.state.action,
                emailId:  this.state.actionKey.id,
            };
        }
    }

    validate = () => {
        if ( this.state.action === 'createGroup' ) {
            if ( this.state.name.length < 2 || this.state.name.length > 200 ) {
                this.setState({
                    alert: {
                        error: true,
                        message: 'Số ký tự của tiêu đề nhóm email phải lớn hơn 5 ký tự hoặc nhỏ hơn 200 ký tự'
                    }
                })
                return false;
            }
        }
        return true;
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý email dịch vụ"} page={"Email"} icon={<FaEnvelope className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody className="table-responsive">
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary mr-1" onClick={ () => this.showModal( null, 'createGroup' ) }>
                                            Tạo nhóm email
                                        </button>
                                        <Link className="btn btn-success" to="/admin/email/tao-email-dich-vu.html">
                                            Tạo email
                                        </Link>
                                    </div>
                                    <div className="dataTables_wrapper form-inline dt-bootstrap">
                                        <div className="list-group-email row">
                                            <div className="col-md-12">
                                                {
                                                    this.checkNotification()
                                                }
                                            </div>
                                            <div className="col col-md-12 col-sm-12">
                                                { this.screentGroupEmail() }
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminEmailService' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ServiceListEmailPage);